import { getMyIpMediaResourceKey, getMyIpMediaUrl } from './mediaUrl';
import type { MyIpProfile } from './types';

/** 仅信任当前 IP 已记录的生成图片身份；旧数据没有来源时不添加水印。 */
export function isMyIpGeneratedImage(profile: MyIpProfile, url?: string): boolean {
  const key = url && getMyIpMediaResourceKey(url);
  return Boolean(key && Array.isArray(profile.generated_image_keys) && profile.generated_image_keys.includes(key));
}

/** 从 Agent 的图片产物事件记录来源，不把摘要中引用的用户图片当成生成结果。 */
export function getMyIpGeneratedImageKeys(raw: unknown): string[] {
  if (!raw || typeof raw !== 'object') return [];
  const data = raw as Record<string, unknown>;
  if (data.type !== 'media_result' || !Array.isArray(data.media_items)) return [];
  return data.media_items.flatMap((entry) => {
    if (!entry || typeof entry !== 'object') return [];
    const media = entry as Record<string, unknown>;
    if ((media.media_type || data.media_type) !== 'image' || media.source === 'upload' || media.source === 'material') return [];
    return [media.media_url, media.url, media.ori_media_url].flatMap((url) => (
      getMyIpMediaUrl(url) ? [getMyIpMediaResourceKey(url)] : []
    ));
  });
}

/** 来源元数据随既有 profile 保存，签名刷新不改变身份；无生成记录不新增字段。 */
export function withMyIpGeneratedImages(profile: MyIpProfile, keys: Iterable<string>): MyIpProfile {
  const previous = Array.isArray(profile.generated_image_keys)
    ? profile.generated_image_keys.filter((key): key is string => typeof key === 'string') : [];
  const merged = [...new Set([...previous, ...keys])];
  return merged.length ? { ...profile, generated_image_keys: merged } : profile;
}
